import React from 'react';
import styled from 'styled-components';
import numeral from 'numeral';
import AnimatedNumber from 'react-animated-number';
import PropTypes from 'prop-types';

import { ResponsivePie } from '@nivo/pie';

const HeaderContainer: any = styled.div`
  position: absolute;
  top: ${(props: any) => (props.semi ? '65%' : '50%')};
  left: 0;
  width: 100%;
  text-align: center;
`;

const HeaderValue = styled.div`
  font-size: 24px;
  font-weight: 400;
  color: #797775;
  line-height: 26px;
`;

const HeaderText = styled.div`
  font-size: 14px;
  font-weight: 300;
  text-transform: uppercase;
  color: #8d9096;
`;

const colourScheme = ['#4caf50', '#ffa000', '#f44336'];

type INivoGaugeProps = {
  value: number;
  target: number;
  subTitle?: string | null;
  height: number;
  semi?: boolean;
  graphColours?: Array<`#${string}`>;
  valueMask?: string | null;
  color?: `#${string}`;
  fontSize?: number;
  foreColour?: `#${string}`;
};

const NivoGauge = ({
  value,
  target,
  subTitle,
  height,
  semi,
  graphColours,
  valueMask,
  color,
  fontSize,
  foreColour,
}: INivoGaugeProps) => {
  let percent = Math.abs(Math.round((value / target) * 100.0) / 100.0);
  if (percent > 1) percent = 0.99; //Prevent going over 100%, progress bar does not act sensibly in this scenario.

  const scheme = graphColours || colourScheme;

  const data = [
    {
      id: 'value',
      label: 'value',
      value: value,
      color: scheme[2 - Math.floor(percent * 3)],
    },
    {
      id: 'targetMinusValue',
      label: 'target',
      value: target - value,
      color: '#EEEEEE',
    },
  ];

  const startAngle = semi ? -90 : 0;
  const endAngle = semi ? 90 : 360;

  return (
    <>
      <HeaderContainer semi={semi}>
        <HeaderValue style={{ color: color }}>
          <AnimatedNumber
            value={value}
            style={{
              transition: '0.8s ease-out',
              fontSize: fontSize,
              transitionProperty: 'color, opacity',
              color: foreColour,
            }}
            duration={1000}
            formatValue={(value) => numeral(value).format(valueMask)}
          />
        </HeaderValue>
        <HeaderText style={{ color: color }}>{subTitle}</HeaderText>
      </HeaderContainer>
      <div style={{ height: height, width: '100%', position: 'relative' }}>
        <ResponsivePie
          data={data}
          margin={{ bottom: 0 }}
          startAngle={startAngle}
          endAngle={endAngle}
          innerRadius={0.75}
          padAngle={0.7}
          cornerRadius={3}
          colors={{ datum: 'data.color' }}
          borderWidth={1}
          borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
          valueFormat={(value) => numeral(value).format(valueMask)}
        />
      </div>
    </>
  );
};

NivoGauge.propTypes = {
  value: PropTypes.number,
};
NivoGauge.defaultProps = {
  value: 0,
  valueMask: '0,00.00',
};

export default NivoGauge;
